import { gql } from '@apollo/client';

export const CHALLENGE_CUSTOMER = gql`
  mutation ChallengeCustomer($input: ChallengeCustomer) {
    challengeCustomer(input: $input) {
      id
      status
      customerUid
      externalVerificationType
      verificationMethod
      verificationCriteria {
        externalVerificationType
        email
        hsaId
        context
      }
      startedAt
      createdAt
      errorMessage
      errorCode
    }
  }
`;
